$(document).ready(function() {
  /*
   * Agecheck
   */
  window.adult = function (e) {
    var confirmationExpiration = new Date().getTime() + 90*60*60*24*1000; // 90 days
    window.localStorage.setItem( 'age-checker-confirmation', confirmationExpiration );

    checkAge();
    e.preventDefault();
  }

  window.underage = function (e) {
    $('.agecheck__wrap').css({ 'height': $('.agecheck__wrap').outerHeight() });
    $('.agecheck__whatage').fadeOut(700, function () {
      $('.agecheck__underage').fadeIn();
    });
    e.preventDefault();
  }

  function checkAge() {
    var now = new Date().getTime()
    if( ( window.localStorage.getItem( 'age-checker-confirmation' ) !== null
        && window.localStorage.getItem( 'age-checker-confirmation') > now ) ||
        document.referrer.includes( 'https://www.budejovickybudvar.cz/' )  ) {
      document.querySelector('html').classList.add('adult');

      //document.dispatchEvent(new Event('adultLoaded'));
      var event;
      if (typeof (Event) === 'function') {
        event = new Event('adultLoaded');
      } else {
        event = document.createEvent('Event');
        event.initEvent('adultLoaded', true, true);
      }
      document.dispatchEvent(event);

    } else {
      document.querySelector('html').classList.add('agecheck');
      $('#age-verification').addClass('not-verified');
    }
  }

  checkAge();

  /*
   * Gallery carousel
   */

  const carouselEl = document.querySelector( '.gallery__carousel' );
  const flkty = new Flickity( carouselEl, {
    // options
    cellAlign: 'center',
    setGallerySize: false,
    selectedAttraction: 0.01,
    friction: 0.15,
    //contain: true
  });

  /*
   * Modals
   */

  // open
  const modalBtns = document.querySelectorAll( '.btn--modal:not(.btn--disabled)' );

  modalBtns.forEach( el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      const modalClass = el.hash.replace( '#', '' );
      document.querySelector( `.modal.${modalClass}` ).classList.add( 'modal--active' );
      document.body.classList.add( 'is-modal-active' );
    });
  });

  // close
  const modalCloseBtns = document.querySelectorAll( '.modal__close' );

  modalCloseBtns.forEach( el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      document.querySelector( '.modal--active' ).classList.remove( 'modal--active' );
      document.body.classList.remove( 'is-modal-active' );
    });
  });


  /*
   * Initialize Animate on Scroll
   */
  AOS.init({
    duration: 650,
  });




  /*
   * Scrollmagic magic
   */


  /********
   *********   SCROLL MAGIC! **********
   ********/

  let controller = new ScrollMagic.Controller();

  /********
   *********   INTRO SECTION (BOTTLE, LEAVES)
   ********/

  // Calculate hero pinning duration!!
  // we cannot use just percentage as it jumps on iOS scroll down and up (bar issue)

  let introPinDuration = 0,
      getIntroPinDuration = () => (introPinDuration),
      setIntroPinDuration = () => {
        const vh = document.documentElement.clientHeight || 0;

        setTimeout(() => {
          introPinDuration =
            document.querySelector('.hero').offsetHeight +
            vh * 0;
        }, 200);
      };

  setIntroPinDuration();

  window.addEventListener('resize', debounce(() => setIntroPinDuration(), 200, false), false);
  window.addEventListener('orientationchange', () => setIntroPinDuration(), false);


  // Scene 1 - Pinning
  const pinScene1 = new ScrollMagic.Scene({
    offset: 0,
    triggerHook: 0,
    duration: getIntroPinDuration,
    //duration: '100%'
  })
  //.addIndicators({ name: 'pinscene1' })
  .setPin('.hero', {
    pushFollowers: true,
  })
  .addTo(controller);


  // Scene 1 - tweening
  const tl1 = gsap.timeline();

  tl1.to('.hero__palm1__pic', {
      x: '-12vw',
      /*y: '-50%', */
      rotation: '-18deg',
      duration: 1
    })
    .to('.hero__palm2__pic', {
      x: '-12vw',
      /*y: '-50%', */
      rotation: '-18deg',
      duration: 1
    }, '-=1')
    .to('.hero__banana__pic', {
      /* x: '-30vw',*/
      y: '20%',
      rotation: '-25deg',
      duration: 1
    }, '-=1')
    .from('.hero__content', {
      scale: 0.5,
      duration: 1
    }, '-=1');

  const scene1 = new ScrollMagic.Scene({
    offset: 0,
    duration: getIntroPinDuration,
    triggerHook: 0,
  })
  //.addIndicators({ name: 'tweenscene1' })
  .setTween(tl1)
  .addTo(controller);


  // Product intro class
  new ScrollMagic.Scene({
    triggerElement: '.intro__content',
    triggerHook: 0.66
  })
  .setClassToggle('.intro__content', 'animated')
  .reverse(true)
  //.addIndicators()
  .addTo(controller);


  // Side images in parallax
  const paraSides = document.querySelectorAll('.parasides');

  paraSides.forEach(img => {
    new ScrollMagic.Scene({
      triggerElement: img,
      duration: '200%',
      triggerHook: 1,
    })
    //.addIndicators({ name: 'tweenscene2' })
    .setTween(gsap.to(img, {
      y: '-=40%',
      duration: 1
    }))
    .addTo(controller);
  });

  // Scrolldown icon rotation

  // Calculate Scrolldown animation duration
  // Whole page scroll

  let pageDuration = 0,
      getPageDuration = () => (pageDuration),
      setPageDuration = () => {
        let vh = document.documentElement.clientHeight || 0;

        setTimeout(() => {
          pageDuration =
            document.querySelector('body').offsetHeight +
            vh * 0;
          //console.log('set page duration', pageDuration);
          //alert('page duration set', pageDuration);
        }, 200);
      };
  setPageDuration();

  window.addEventListener('resize', debounce(() => setPageDuration(), 200, false), false);
  window.addEventListener('orientationchange', () => setPageDuration(), false);


  const tlScrolldown = gsap.timeline();

  tlScrolldown
  .to('#scrolldown__ring', {
    rotation: '720deg',
    duration: 15
  });

  new ScrollMagic.Scene({
    offset: 0,
    duration: getPageDuration,
    triggerHook: 0,
    reverse: true
  })
  // .addIndicators({ name: 'tweenSCD' })
  .setTween(tlScrolldown)
  .addTo(controller);

});